// initial state
import * as base from './base.js'
const baseName = '/admin/ordersType'

const ordersTypeList = baseName + '/list'
const ordersTypeSelectLike = baseName + '/selectLike'


const obj = base.setBaseUrl('ordersType', baseName)
const obj1 = base.setBaseUrl('ordersType', ordersTypeList)
const obj2 = base.setBaseUrl('ordersType',ordersTypeSelectLike)

const a = Object.assign(obj, obj1,obj2,{ ordersTypeList,ordersTypeSelectLike})
export default a
